import React, { useState } from 'react';

interface MaintenanceItemProps {
  reminder: any;
  currentMileage: number;
}

const MaintenanceItem: React.FC<MaintenanceItemProps> = ({ reminder, currentMileage }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { type_name, status, last_service, next_km, next_date, interval_km } = reminder;

  // Mapa de iconos según el nombre
  const getIcon = (name: string) => {
    if (name.includes('Aceite')) return '🛢️';
    if (name.includes('Neumáticos') || name.includes('Alineación')) return '🛞';
    if (name.includes('Filtro de Aire')) return '🌬️';
    if (name.includes('Filtro de Habitáculo')) return '🍃';
    if (name.includes('Filtro de Nafta')) return '⛽';
    if (name.includes('Líquido de Frenos')) return '🛑';
    if (name.includes('Correa')) return '⛓️';
    if (name.includes('Bujías')) return '⚡';
    if (name.includes('Batería')) return '🔋';
    if (name.includes('Refrigerante')) return '❄️';
    return '🔧';
  };

  // Cálculos de tiempo y distancia
  const getRemainingText = () => {
    if (!last_service) return "Sin registros previos";
    
    const kmLeft = next_km - currentMileage;
    const dateLeft = next_date ? Math.ceil((new Date(next_date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) : null;

    if (kmLeft <= 0 || (dateLeft !== null && dateLeft <= 0)) {
      return "VENCIDO";
    }

    let text = `Faltan ${kmLeft.toLocaleString()} KM`;
    if (dateLeft !== null) text += ` o ${dateLeft} días`;
    return text;
  };

  const getLitClass = () => {
    if (status === 'overdue') return 'lit-red';
    if (status === 'warning') return 'lit-warning';
    return 'lit-ok';
  };

  return (
    <div 
      className={`maintenance-witness-container ${isExpanded ? 'expanded' : ''}`}
      style={{ position: 'relative' }}
    >
      <div 
        className={`witness-light-pro ${getLitClass()}`}
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ 
          cursor: 'pointer',
          background: 'linear-gradient(145deg, #0f172a, #000)',
          boxShadow: 'inset 2px 2px 5px rgba(255,255,255,0.05), inset -2px -2px 5px rgba(0,0,0,0.5), 0 5px 15px rgba(0,0,0,0.5)',
          border: '1px solid rgba(255,255,255,0.1)'
        }}
        title={type_name}
      >
        <span style={{ filter: 'drop-shadow(0 0 5px currentColor)' }}>{getIcon(type_name)}</span>
      </div>

      {isExpanded && (
        <div 
          className="expanded-modal-info" 
          style={{ 
            position: 'absolute', 
            top: '100%', 
            left: '50%', 
            transform: 'translateX(-50%)', 
            zIndex: 100, 
            width: '260px', 
            background: '#111', 
            padding: '1rem', 
            borderRadius: '12px', 
            border: '1px solid #333',
            boxShadow: '0 10px 30px rgba(0,0,0,0.8)',
            marginTop: '10px'
          }}
        >
          <div style={{ fontWeight: 'bold', marginBottom: '0.5rem', color: 'white' }}>{type_name}</div>
          <div style={{ fontSize: '0.75rem', color: '#999', marginBottom: '0.5rem' }}>{getRemainingText()}</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.7rem' }}>
             <div>Ult: {last_service ? new Date(last_service.service_date).toLocaleDateString() : 'N/A'}</div>
             <div>Prox: {next_km ? `${next_km.toLocaleString()} KM` : 'N/A'}</div>
          </div>
          <button 
            className="btn btn-primary" 
            style={{ width: '100%', marginTop: '0.75rem', padding: '0.3rem', fontSize: '0.7rem' }}
            onClick={(e) => { e.stopPropagation(); setIsExpanded(false); }}
          >Cerrar</button>
        </div>
      )}
    </div>
  );
};

export default MaintenanceItem;
